// extracted by mini-css-extract-plugin
export var ingredients = "Drink-module--ingredients--uOn08";
export var ingredients__list = "Drink-module--ingredients__list--TSGuu";
export var ingredients__listItem = "Drink-module--ingredients__list-item--dgs9S";
export var ingredients__title = "Drink-module--ingredients__title--vQ4jA";
export var ingredients__titleBorder = "Drink-module--ingredients__title-border--zIWyZ";
export var paragraph = "Drink-module--paragraph--k-w0v";
export var title = "Drink-module--title--x3KFo";
export var title__border = "Drink-module--title__border--MeWQx";
export var wrapper = "Drink-module--wrapper--NwzNL";